<template>
    <h2 class="text-headline-secondary">
        <slot />
    </h2>
</template>

<style scoped lang="scss">
$element-TextHeadlineSecondary-color: inherit !default;
$element-TextHeadlineSecondary-font: 600 1.5rem $font-family !default;
$element-TextHeadlineSecondary-text-transform: none !default;
$element-TextHeadlineSecondary-margin-bottom: 1rem !default;

.text-headline-secondary {
    margin: 0;
    margin-bottom: $element-TextHeadlineSecondary-margin-bottom;
    font: $element-TextHeadlineSecondary-font;
    color: $element-TextHeadlineSecondary-color;
    text-transform: $element-TextHeadlineSecondary-text-transform;
}
</style>
